import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  inject
} from '@angular/core';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MultiSelectComponent implements OnChanges {
  private _utilityService = inject(UtilityService);

  @Input() disabled: boolean = false;
  @Input() Items = new Map<string, any>();
  @Input() inputSelectedItems = new Map<string, any>(); // Pre-selection

  @Output() selectedItemsChange = new EventEmitter<Map<string, any>>();

  selectedItems = new Map<string, any>();
  selectAllItems: boolean = false;
  selectAllItemsUniqueId = Math.random().toString(36);

  preserveMapOrder = this._utilityService.keyValuePairDefaultOrder;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputSelectedItems']) {
      this.selectedItems = new Map(this.inputSelectedItems ?? []);
      this.selectAllItems =
        this.Items.size > 0 && this.selectedItems.size === this.Items.size;
    }
  }

  onBadgeClick(event: Event): void {
    event.stopPropagation();
  }

  selectionChange(event: Event, selectedItem: KeyValue<string, any>) {
    event.stopPropagation();

    const hasItem = this.selectedItems.has(selectedItem.key);

    if (!hasItem) {
      this.selectedItems.set(selectedItem.key, selectedItem.value);
    } else {
      this.selectedItems.delete(selectedItem.key);
    }

    this.emitSelection();
  }

  selectAll() {
    this.selectAllItems = !this.selectAllItems;

    this.selectedItems.clear();

    if (this.selectAllItems) {
      this.Items.forEach((value, key) => this.selectedItems.set(key, value));
    }

    this.emitSelection();
  }

  emitSelection() {
    this.selectedItemsChange.emit(new Map(this.selectedItems));
  }
}
